import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';
@Component({
  selector: 'app-json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe]
})
export class JsonViewerComponent implements OnInit {
  formattedCurrData: any;
  formattedPreData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<JsonViewerComponent>,
    private datePipe: DatePipe,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.formattedCurrData = this.translateAndFormatJson(this.data?.curr_data || {});
    this.formattedPreData = this.translateAndFormatJson(this.data?.pre_data || {});
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  // Recursive funciton to support nested JSON objects
  translateAndFormatJson(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.translateAndFormatJson(item));
    }

    if (obj !== null && typeof obj === 'object') {
      const translated: any = {};

      for (const rawKey in obj) {
        // Check to skip inherited properties that are not directly defined on the object
        if (!Object.prototype.hasOwnProperty.call(obj, rawKey)) continue;

        const key: string = String(rawKey);
        const val = obj[key];

        if (key.trim() === '' || val === undefined || val === null) continue;

        const translatedKey = this._translateService.instant(key);

        if (this.isDate(val)) {
          translated[translatedKey] = this.datePipe.transform(val, 'dd/MM/yyyy - HH:mm:ss');
        } else if (typeof val === 'string' && val.trim() !== '') {
          translated[translatedKey] = this._translateService.instant(val);
        } else {
          translated[translatedKey] = this.translateAndFormatJson(val);
        }
      }
      return translated;
    }
    return obj;
  }

  // Date validation function to check if a string is in ISO format
  isDate(value: any): boolean {
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value) && !isNaN(Date.parse(value));
  }

  isEmpty(value: any): boolean {
    return isEmpty(value);
  }
}
